<div class="row">
    <div class="form-group {{fileColumnClass}}">
        <label>{{fieldLabel}}
            <span *ngIf="showAsRequired" style="color:red"> * </span></label>
        <div style="position:relative; z-index: 0; background: rgba(0,0,0,0.5);border-radius: 0.25rem;"
            (click)="loadFile($event, 'fileDescriptorReference')">
            <a class='btn upload-file btn-block'>
                <i class="fa fa-file file-no-load" width="100" height="100" *ngIf="!fileDescriptorBase64"></i>
                <img width="100" height="100" [src]="cleanURL(fileDescriptorBase64)" style="z-index: 1;"
                    *ngIf="isImage && fileDescriptorBase64">
                <div class="file-preview-other" *ngIf="!isImage && fileDescriptorBase64">
                    <span class="file-other-icon" style="font-size: 1em;"><i class="fa fa-file"></i></span>
                </div>
                <input type="file" [accept]="validMymeTypeFormat" [size]="maxSize" [disabled]="disabled"
                    (change)="photoChange($event, 'fileDescriptorReference')" style="display: none;"
                    #fileDescriptorReference>
            </a>
        </div>
        <div class="file-thumbnail-footer mt-1" *ngIf="fileName">
            <div class="file-footer-caption" title="{{fileName}}">
                <div class="file-caption-info">
                    <a>{{fileName}}</a><br />
                    <button (click)="showFilePreview()" type="button" class="btn btn-outline-danger btn-sm mt-3"
                        *ngIf="showPreview">Vista
                        Previa</button>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group col-md-6 text-left" style="margin-top: -0.3%;" *ngIf="showContent">
        <ng-content></ng-content>
    </div>
</div>